import { useState } from "react"
import Header from "./Header"
import Footer from "./Footer"
// import Session from "./Session"

import NavMain from "../nav/NavMain"
import use2FAPending from "../hooks/use2FAPending"
import { Link } from "react-router-dom"
import MessageBanner from "../components/GlobalBanner/MessageBanner"
import PopupBanner from "../components/GlobalBanner/PopupBanner"
import use2FADeadlineMet from "../hooks/use2FADeadlineMet"

export default function Layout({ children }) {
  const [toogle, setToogle] = useState(true)
  const [showBanner, setShowBanner] = useState(true)
  const handleClassName = toogle ? "expand" : "collapse"
  const isPending2FA = use2FAPending()
  const deadlinePassed = use2FADeadlineMet()

  const messages = [
    "Your account is required to have Two Factor Authentication enabled.",
  ]

  const handleCloseBanner = () => {
    setShowBanner(false)
  }

  return (
    <>
      {isPending2FA && showBanner && (
        <MessageBanner messages={messages} onClose={handleCloseBanner} />
      )}

      {isPending2FA && deadlinePassed && (
        <PopupBanner messages={messages} onClose={handleCloseBanner} />
      )}

      <div
        className={`theme-wrapper ${handleClassName}`}
        style={{ gridTemplateRows: "88px auto 40px" }}
      >
        <Header />
        <NavMain setToogle={setToogle} toogle={toogle} />
        <main className="body-main">{children}</main>
        <Footer />
      </div>
    </>
  )
}
